'use client';

var __jsx = React.createElement;
import React from 'react';
import { useCustomer } from '@lib/context/shared/customer-context';
import EntityPointsDisplay from '@modules/shared/components/points-quantity-display';
import { ArrowPathIcon } from '@heroicons/react/20/solid';
import { MuscleButton } from '@modules/shared/components/buttons';
import { cn } from '@lib/cn';
import { useBenefitLogin } from '@lib/context/shared/benefit-iframe-context';
import { useNotifications } from '@lib/context/shared/notifications-context';
import { useTranslations } from 'next-intl';
import { NotificationType } from 'types/shared/notification-types';
import APP_CONFIGURATION from '@lib/app.config';
import useTrackEvent from '@lib/hooks/use-track-event';
import { MIXPANEL_EVENTS } from '@lib/mixpanel/mixpanel.event-list';
import Icons from '@modules/icons';
import { useErrorPage } from '@lib/context/shared/errors-context';
import useMuscleRouter from '@lib/hooks/use-muscle-router';
import useCssModules from '@lib/hooks/use-css-modules';
const HeaderAvailablePointsDisplay = _ref => {
  let {
    smallDisplay = false,
    allowRefreshPoints = false
  } = _ref;
  const {
    customerAvailablePoints,
    refreshAvailablePoints,
    refreshingPoints,
    checkActiveProviderSession,
    isSessionProviderActive,
    logoutFromFrontend,
    isLoadingCustomer
  } = useCustomer();
  const {
    openBenefitLogin
  } = useBenefitLogin();
  const {
    notify
  } = useNotifications();
  const t = useTranslations('Shared');
  const [isLoadingStatus, setIsLoadingStatus] = React.useState(false);
  const trackEvent = useTrackEvent();
  const {
    renderErrorPage
  } = useErrorPage();
  const tShared = useTranslations("Shared");
  const router = useMuscleRouter();
  const {
    cssModules
  } = useCssModules();
  const {
    headerPointsContainerClassNames,
    headerPointsValueClassNames,
    headerPointsLabelClassNames,
    headerRefreshPointsButtonClassNames,
    headerPointsIconClassNames,
    headerSpanPointsClassNames
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.account.header) || {};
  const checkProviderSession = async () => {
    setIsLoadingStatus(true);
    const isActiveSession = await checkActiveProviderSession();
    if (!isActiveSession) {
      trackEvent(MIXPANEL_EVENTS.Profile.ENTITY_USER_LAPSED_SESSION);
      if (APP_CONFIGURATION.config.render_error_page_on_auth_validate && !isLoadingCustomer) {
        logoutFromFrontend(true);
        renderErrorPage({
          code: "no_session_found",
          subtitle: tShared("WHAT_CAN_I_DO"),
          title: tShared("Errors.PAGE_ERRORS.NO_SESSION_FOUND.TITLE"),
          message: tShared.rich("Errors.PAGE_ERRORS.NO_SESSION_FOUND.MESSAGE", {
            bankEntity: APP_CONFIGURATION.config.appName,
            supportPhoneNumber: APP_CONFIGURATION.config.contactInformation.phoneNumber,
            strong: chunks => __jsx("span", {
              className: "tx-plg-medium"
            }, chunks)
          }),
          addButton: false
        });
      } else {
        openBenefitLogin(true);
      }
    } else {
      await refreshAvailablePoints();
      trackEvent(MIXPANEL_EVENTS.Profile.POINTS_REFRESHED);
      notify(t("Auth.USER_REFRESH_POINTS", {
        providerPointsName: APP_CONFIGURATION.config.pointsCurrencyShort,
        points: customerAvailablePoints.toLocaleString()
      }), NotificationType.SUCCESS);
    }
    setIsLoadingStatus(false);
  };
  return __jsx("div", {
    className: headerPointsContainerClassNames,
    onClick: () => {
      if (smallDisplay && allowRefreshPoints && !isLoadingStatus) {
        checkProviderSession();
      }
    }
  }, __jsx(EntityPointsDisplay, {
    isHeader: true,
    quantity: customerAvailablePoints,
    contrastText: true,
    pointsClassName: headerPointsValueClassNames,
    useShortPointsName: true,
    breakOnMobile: true,
    brandClassName: headerPointsLabelClassNames,
    pointNameIconClassName: headerPointsIconClassNames,
    textClassname: headerSpanPointsClassNames
  }), !smallDisplay && __jsx("div", null, allowRefreshPoints ? __jsx(MuscleButton, {
    dataTestId: "header-refresh-points-button",
    variant: "link",
    disabled: isLoadingStatus,
    onClick: checkProviderSession
  }, __jsx(ArrowPathIcon, {
    className: cn(headerRefreshPointsButtonClassNames, isLoadingStatus && 'animate-spin')
  })) : __jsx(Icons.info, {
    size: 18,
    className: "text-white"
  })));
};
export default HeaderAvailablePointsDisplay;